var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNmapAppIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#256CFA",
    d: "M5.979 11.969H18v3.125H5.988l-.01-3.125Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#03C75A",
    d: "M5.967 1.61c-2.722 0-4.925 2.192-4.925 4.899 0 .933.251 1.804.71 2.547l4.101 5.976a.136.136 0 0 0 .228 0l4.1-5.976c.456-.743.711-1.614.711-2.547 0-2.707-2.203-4.899-4.925-4.899Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.586 6.635 5.341 4.838a.145.145 0 0 0-.12-.063H4.29a.061.061 0 0 0-.061.06V8.19c0 .033.027.061.06.061h.999c.033 0 .06-.028.06-.061v-1.8l1.246 1.798c.027.04.071.063.12.063h.93c.034 0 .061-.028.061-.061V4.836a.061.061 0 0 0-.06-.062h-.998a.061.061 0 0 0-.061.062v1.799Z"
  })));
}
export default SvgNmapAppIcon;